/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
// @flow
import * as React from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
// import { useHistory } from 'react-router';
import styles from './styles.module.scss';
import FooterABC from '../../containers/Footer/footerABC';
import P from '../../components/Typography/P';
import actionTypes from '../../store/profile/actionTypes';
import Preloader from '../../components/Preloader';
import { Button, H2 } from '../../components';
import Table from '../../components/Table';
import Modal from '../../components/ModalProfile';
import classnames from 'classnames';
import Switch from '../../components/Switch/switch';
import Pricing from '../Pricing/Pricing';
import ReferralPayments from './referralPayments';
import ReferralHistory from './referralHistory';
// import { PRICE_KEY } from '../../constants/payments';

const COLUMNS = [
  {
    Header: 'Date',
    accessor: 'payment_date',
  },
  {
    Header: 'Method',
    accessor: 'payment_method',
  },
  {
    Header: 'Rate',
    accessor: 'type',
  },
  {
    Header: 'Amount',
    accessor: 'value',
  },
];

const name = {
  advanced: 'Advanced',
  basic: 'Basic',
  basicannual: 'Basic',
  advancedannual: 'Advanced',
  plo4: 'PLO4',
  plo5: 'PLO5',
  plo4plo5: 'PLO4+PLO5',
  plo4annual: 'PLO4',
  plo5annual: 'PLO5',
  plo4plo5Annual: 'PLO4+PLO5',
  plo4plo5annual: 'PLO4+PLO5',
};

const prices = {
  plo4: '€45/month',
  plo5: '€45/month',
  plo4plo5: '€70/month',
  plo4annual: '€33.75/month',
  plo5annual: '€33.75/month',
  plo4plo5Annual: '€55/month',
  plo4plo5annual: '€55/month',
};

const MODAL_INFO_INIT = {
  title: '',
  handler: () => {},
};

const PENDING_REFRESH_INTERVAL = 5000;
const PENDING_REFRESH_LIMIT = 6;

type ModalInfo = {
  title: string,
  handler: (any) => void,
};

type UpgradeModalInfo = {
  title: string,
  id: string,
  to: string,
};

const UPGRADE_MODAL_INFO_INIT = {
  title: '',
  id: '',
  to: '',
};

const Profile = () => {
  // const history = useHistory();
  const dispatch = useDispatch();
  const isLoaderTariff = useSelector((state) => state.api.GET_PROFILE_INFO.loading);
  const myRef = React.useRef(null);
  const [isYear, setIsYear] = React.useState<boolean>(false);
  const [modalInfo, setModalInfo] = React.useState<ModalInfo>(MODAL_INFO_INIT);
  const [pendingRefreshAttempts, setPendingRefreshAttempts] = React.useState(0);
  // eslint-disable-next-line max-len
  const [upgradeModalInfo, setUpgradeModalInfo] = React.useState<UpgradeModalInfo>(UPGRADE_MODAL_INFO_INIT);

  React.useEffect(() => {
    dispatch({ type: actionTypes.GET_PROFILE_INFO });
    dispatch({ type: actionTypes.GET_REF_SETTINGS });
    dispatch({ type: actionTypes.GET_REF_PAYMENTS });
    dispatch({ type: actionTypes.GET_REF_USERS });
  }, []);

  const { user, payments } = useSelector((state) => state.profile);

  const isLoadingProfileInfo = useSelector((state) => state.api.GET_PROFILE_INFO.loading);
  const isLoadingCancelSub = useSelector((state) => state.api.CANCEL_SUB.loading);
  const isSuccessCancelSub = useSelector((state) => state.api.CANCEL_SUB.success);
  const isErrorCancelSub = useSelector((state) => state.api.CANCEL_SUB.error);

  const isLoadingReactivateSub = useSelector((state) => state.api.REACTIVATE_SUB.loading);
  const isSuccessReactivateSub = useSelector((state) => state.api.REACTIVATE_SUB.success);
  const isErrorReactivateSub = useSelector((state) => state.api.REACTIVATE_SUB.error);

  React.useEffect(() => {
    setModalInfo(MODAL_INFO_INIT);
  }, [isSuccessCancelSub, isErrorCancelSub, isErrorReactivateSub, isSuccessReactivateSub]);

  const handlerCancelSub = () => {
    dispatch({ type: actionTypes.CANCEL_SUB, payload: true });
  };

  const handlerReactivateSub = () => {
    dispatch({ type: actionTypes.REACTIVATE_SUB });
  };

  const modalInfoToCancelButton = {
    title: 'Are you sure You want to cancel your subscription?',
    handler: handlerCancelSub,
  };

  const modalInfoToResumeButton = {
    title: 'Are you sure You want to resume your subscription?',
    handler: handlerReactivateSub,
  };

  const handleStatus = (status) => {
    if (status === 'ok') {
      return '';
    }
    return `(${status})`;
  };

  const rates = ['basic', 'advanced', 'basicannual', 'advancedannual', 'plo4', 'plo5', 'plo4plo5', 'plo4annual', 'plo5annual', 'plo4plo5annual'];
  const isSubscribe = rates.includes(user.rate);
  const isActivePaymentStatus = user.payment_status === 'active';
  const isPendingPaymentStatus = user.payment_status === 'pending';
  const isCanceledPaymentStatus = user.payment_status === 'canceled';
  const isPausedPaymentStatus = user.payment_status === 'paused';
  const paymentMethod = user.payment_method;

  React.useEffect(() => {
    setPendingRefreshAttempts(0);
    if (!isPendingPaymentStatus) return undefined;

    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      dispatch({ type: actionTypes.GET_PROFILE_INFO });
      setPendingRefreshAttempts(attempts);
      if (attempts >= PENDING_REFRESH_LIMIT) clearInterval(timer);
    }, PENDING_REFRESH_INTERVAL);

    return () => clearInterval(timer);
  }, [dispatch, isPendingPaymentStatus, user.id]);
  // const isBasicActive = user?.rate === 'basic' && user?.payment_status === 'active';
  // const isBasicAnnualActive = user?.rate === 'basicannual' && user?.payment_status === 'active';
  const byAdmin = user.payment_method === 'by Admin';
  const isDev = window.location.host.includes('develop') || window.location.host.includes('localhost');
  const unsubscribeHref = isDev ? 'https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_subscr-find&alias=67GJRXM2ZJYFJ' : 'https://www.paypal.com/cgi-bin/webscr?cmd=_subscr-find&alias=RKLD69HRH8X9J';
  const isSubscriptionExpired = user.payment_date
    ? moment().format() > moment(user.payment_date).format() : null;

  const handlePurchaseButton = () => {
    if (isPendingPaymentStatus) return null;

    if ((!isSubscribe || isCanceledPaymentStatus || isSubscriptionExpired)) {
      return (
        <button
          className={styles.buttonSelect}
          label="Select subscription"
          type="button"
          onClick={() => {
            const rate = document.querySelector('#rate');
            rate.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Select subscription
        </button>
      );
    }

    if (paymentMethod === 'Stripe' && !isLoadingProfileInfo && isSubscribe && isPausedPaymentStatus) {
      return (
        <button
          className={styles.buttonSelect}
          label="Resume"
          type="button"
          onClick={() => setModalInfo(modalInfoToResumeButton)}
        >
          Resume
        </button>
      );
    }

    if (paymentMethod === 'Stripe' && !isLoadingProfileInfo && isSubscribe && isActivePaymentStatus) {
      return (
        <button
          className={styles.buttonSelect}
          label="Upgrade plan"
          type="button"
          onClick={() => {
            const rate = document.querySelector('#rate');
            rate.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Upgrade plan
        </button>
      );
    }

    return null;
  };

  const handleCancelButton = () => {
    if (paymentMethod === 'Paypal' && !isLoadingProfileInfo && isSubscribe && isActivePaymentStatus) {
      return (
        <span
          className={styles.cancelButton}
          onClick={() => { window.location.href = unsubscribeHref; }}
        >
          Cancel subscription
        </span>
      );
    }

    if (paymentMethod === 'Stripe' && !isLoadingProfileInfo && isSubscribe && isActivePaymentStatus) {
      return (
        <span
          className={styles.cancelButton}
          onClick={() => setModalInfo(modalInfoToCancelButton)}
        >
          Cancel subscription
        </span>
      );
    }

    return null;
  };

  // const upgradeHandler = () => {
  //   if (isBasicActive) {
  //     setUpgradeModalInfo({ title: 'Upgrade subscription', id: PRICE_KEY.ADVANCED, to: 'Advanced (€45/month)' });
  //   }
  //   if (isBasicAnnualActive) {
  //     setUpgradeModalInfo({ title: 'Upgrade subscription', id: PRICE_KEY.ADVANCED_YEAR, to: 'Advanced annual (€405/year)' });
  //   }
  // };

  return (
    <section
      className={styles.profileWrapper}
    >
      <Preloader isLoading={isLoadingProfileInfo && !isPendingPaymentStatus}>
        <div className={styles.profile}>
          <H2 color="dark">Profile</H2>

          <div className={styles.profileContainer}>
            <div className={`${styles.box} ${styles.subscription}`}>
              <div className={styles.flexBetween}>
                <span className={styles.boxHeader}>Subscription</span>
                <span>{user.email}</span>
              </div>
              <div className={styles.tariffWrapper}>
                <span className={styles.tariffSpan}>{name[user.rate]}</span>
                {prices[user.rate] && (
                  <div className={styles.tariffPrice}>
                    {prices[user.rate]}
                  </div>
                )}
              </div>
              {isPendingPaymentStatus && (
                <div>
                  <p role="status">
                    {pendingRefreshAttempts < PENDING_REFRESH_LIMIT
                      ? 'Subscription status is pending. Checking for an update…'
                      : 'Your subscription update is still pending. Refresh its status or contact support.'}
                  </p>
                  <Button
                    name="Refresh subscription status"
                    loading={isLoadingProfileInfo}
                    onClick={() => dispatch({ type: actionTypes.GET_PROFILE_INFO })}
                  />
                </div>
              )}
              <div className={`${styles.flexBetween} ${styles.stickBottom}`}>
                <span>{handlePurchaseButton()}</span>
                <span>{handleCancelButton()}</span>
              </div>
            </div>
            <ReferralPayments />
          </div>
          <div className={styles.profileContainer}>
            <div className={styles.box}>
              <div className={styles.mb15}>
                <span className={styles.boxHeader}>Subscription payments history</span>
              </div>
              <Table
                data={payments}
                showPagination
                resizable={false}
                col={COLUMNS}
                defaultPageSize={10}
                showPaginationBottom={false}
                className="-striped -highlight"
                pages={payments.length / 10}
              />
            </div>
            <ReferralHistory />
          </div>
          <div ref={myRef} className={classnames(styles.pricingContainer, styles.section)} id="rate">
            <H2 color="dark" className={styles.headerText}>Pricing</H2>
            <div className={styles.priceSwitch}>
              <div className={styles.priceSwitchWrapper}>
                <div className={styles.text}>Annual</div>
              </div>
              <Switch
                switchCheckboxStyles={styles.switchCheckbox}
                switchButtonStyles={styles.switchButton}
                switchLabelStyles={styles.switchLabel}
                isOn={isYear}
                handleToggle={() => setIsYear(!isYear)}
              />
              <div className={styles.priceSwitchWrapper}>
                <div className={styles.text}>Monthly</div>
              </div>
            </div>

            <Preloader isLoading={isLoaderTariff && !isPendingPaymentStatus}>
              <Pricing
                user={user}
                isYear={isYear}
                cancelHandler={() => setModalInfo(modalInfoToCancelButton)}
                upgradeModalInfo={upgradeModalInfo}
                setUpgradeModalInfo={() => setUpgradeModalInfo(UPGRADE_MODAL_INFO_INIT)}
                resumeHandler={() => setModalInfo(modalInfoToResumeButton)}
              />
            </Preloader>
          </div>
        </div>
      </Preloader>
      <FooterABC />
      <Modal
        classNameChildren={styles.modal}
        isOpen={!!modalInfo.title}
        onClose={() => setModalInfo(MODAL_INFO_INIT)}
      >
        <div className={styles.titleModal}>
          {modalInfo.title}
        </div>
        <Preloader isLoading={isLoadingCancelSub || isLoadingReactivateSub}>
          <div className={styles.buttonWrapper}>
            <Button
              name="Cancel"
              small
              onClick={() => setModalInfo(MODAL_INFO_INIT)}
            />
            <Button
              name="Submit"
              small
              onClick={modalInfo.handler}
            />
          </div>
        </Preloader>
      </Modal>
    </section>
  );
};

export default Profile;
